import { hexToRgba } from "@/services";
import { residentialSettingsAPI } from "./api";

export const getResidentialSettingsList = async () => {
  try {
    const res = await residentialSettingsAPI.getResidentials();
    return res?.data || [];
  } catch (e) {}
};
export const getResidentialEntrances = async (residentId) => {
  try {
    const res = await residentialSettingsAPI.getEntrances(residentId);
    return (
      res?.data?.map((item) => ({
        ...item,
        entrance_name: `Подъезд ${item.entrance}`,
      })) || []
    );
  } catch (e) {}
};
export const getEntranceApartments = async (params = {}) => {
  try {
    const res = await residentialSettingsAPI.getEntranceApartments(params);
    if (!res) return;
    return { ...res, data: res?.data?.reverse() || [] };
  } catch (e) {}
};
export const getFloorLegendInfo = async (params = {}) => {
  try {
    const res = await residentialSettingsAPI.getFloorLegendInfo(params);
    return res?.data;
  } catch (e) {}
};
export const getEntranceLegendInfo = async (params = {}) => {
  try {
    return await residentialSettingsAPI.getEntranceLegendInfo(params);
  } catch (e) {}
};
export const recalculateFloorValues = async (floor_map_id, params) => {
  try {
    const res = await residentialSettingsAPI.recalculateFloorValues(
      floor_map_id,
      params
    );
    return res?.data;
  } catch (e) {}
};
export const getEntranceColors = async (params = {}) => {
  try {
    const res = await residentialSettingsAPI.getEntranceColors(params);
    if (!res?.data) return [];
    const newGroup = { label: "Новая группа", colour_id: "new_group" };
    const groups = res.data.map((item) => ({
      ...item,
      hex_code: hexToRgba(item.hex_code, 0.5),
      label: "",
      style: { backgroundColor: hexToRgba(item.hex_code, 0.5) },
    }));
    return [newGroup, ...groups];
  } catch (e) {}
};

const floorSchemaDataRefactor = (res) => {
  const flatColors = {};
  if (res?.data?.length)
    res.data?.forEach((item) => {
      if (!flatColors[item.floor_flat_id]) {
        const flatColorsLength = Object.keys(flatColors).length;
        flatColors[item.floor_flat_id] = borderColors[flatColorsLength];
      }
    });
  const lines = res?.data?.filter((item) => item.coord_type !== "POINT");
  const circles = res?.data?.filter((item) => item.coord_type === "POINT");
  const texts = res?.data?.filter(
    (item) => !!item.frame_name && item.center_point
  );
  return {
    ...res,
    data: !!res?.data?.length,
    flatColors,
    lines,
    circles,
    texts,
  };
};
export const getFloorSchema = async (floor_map_id) => {
  const params = { floor_map_id };
  try {
    const res = await residentialSettingsAPI.getFloorSchema(params);
    if (!res) return;
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const getSchemaObjectInfo = async (floor_param_id, project_type_id) => {
  if (!floor_param_id) return;
  const params = { floor_param_id, project_type_id };
  try {
    const res = await residentialSettingsAPI.getObjectInfo(params);
    return res || null;
  } catch (e) {}
};
export const changeFloorGroup = async (body, params = {}) => {
  try {
    const res = await residentialSettingsAPI.changeFloorGroup(body, params);
    if (!res) return;
    return { ...res, data: res?.data?.reverse() || [] };
  } catch (e) {}
};
export const duplicateFloorGroup = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.duplicateFloorGroup(body, params);
    return res || null;
  } catch (e) {}
};
export const duplicateFlatToFloors = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.duplicateFlatToFloors(
      body,
      params
    );
    return res || null;
  } catch (e) {}
};
export const getFloorMapInfo = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorMapInfo(floor_map_id);
    return res?.data;
  } catch (e) {}
};
export const getFloorParamTypes = async () => {
  try {
    const res = await residentialSettingsAPI.getFloorParamTypes();
    return res?.data;
  } catch (e) {}
};
export const getFloorParamFrames = async (resident_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorParamFrames({
      resident_id,
    });
    return res?.data;
  } catch (e) {}
};
export const getFloorRooms = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorRooms({ floor_map_id });
    return res?.data;
  } catch (e) {}
};
export const getFloorMapErrors = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorMapErrors(floor_map_id);
    return res?.data;
  } catch (e) {}
};
export const getFloorFlatRooms = async (flat_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorFlatRooms({ flat_id });
    return res?.data;
  } catch (e) {}
};
export const updateFloorParam = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.updateFloorParam(body, params);
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const updateFloorMapLine = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.updateFloorMapLine(body, params);
    return res;
  } catch (e) {}
};
export const deleteFloorMapLine = async (floor_param_id, params = {}) => {
  if (!floor_param_id) return;
  try {
    const res = await residentialSettingsAPI.deleteFloorMapLine(
      floor_param_id,
      params
    );
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const getBufferParams = async (floor_map_id) => {
  if (!floor_map_id) return;
  try {
    const res = await residentialSettingsAPI.getBufferParams({
      floor_map_id,
    });
    const lines = res?.data?.filter((item) => item.coord_type !== "POINT");
    const circles = res?.data?.filter((item) => item.coord_type === "POINT");
    return { lines, circles };
  } catch (e) {}
};
export const addFloorMap = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.addFloorMap(body, params);
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const createFloorRemont = async (body, params) => {
  try {
    await residentialSettingsAPI.createFloorRemont(body, params);
    return true;
  } catch (e) {}
};
export const blockParamType = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.blockParamType(body, params);
    return res?.data;
  } catch (e) {}
};
export const editFloorMap = async (floor_map_id, body, params) => {
  try {
    const res = await residentialSettingsAPI.editFloorMap(
      floor_map_id,
      body,
      params
    );
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};

export const flattenPoints = (pointsArray) => {
  return pointsArray.reduce((acc, [x, y]) => {
    acc.push(x, y);
    return acc;
  }, []);
};

export const checkFlatFloor = (floor, apartment, addData, isSubmit = false) => {
  if (Number(addData?.flat_num) === Number(apartment.flat_num))
    return !isSubmit;
  if (floor.is_selected) {
    const floorsOffset = Number(addData?.floor) - Number(floor.floor);
    const direction = floorsOffset > 0 ? 1 : -1;
    const offset = Math.abs(floorsOffset);
    const flatNum =
      direction === 1
        ? Number(addData?.flat_num) - offset * addData?.floorFlatLength
        : Number(addData?.flat_num) + offset * addData?.floorFlatLength;
    if (flatNum === Number(apartment.flat_num)) return true;
  }
  return false;
};

export const borderColors = [
  "#FF5733",
  "#33FF57",
  "#3357FF",
  "#FF33A1",
  "#A133FF",
  "#33FFF5",
  "#F5FF33",
  "#FF8C33",
  "#33FF8C",
  "#8C33FF",
  "#FF3333",
  "#33FF33",
  "#3333FF",
  "#FF33FF",
  "#33FFFF",
  "#FF9933",
  "#33FF99",
  "#9933FF",
  "#FF3399",
  "#3399FF",
];

export const onKonvaWheel = (e, stage) => {
  if (!stage) return;
  e.evt.preventDefault();
  // "коэффициент" скорости масштабирования
  const scaleBy = 1.15;

  // Текущий масштаб
  const oldScale = stage.scaleX();

  // Позиция курсора внутри Stage
  const pointer = stage.getPointerPosition();

  // Находим, «куда» будет масштабироваться сцена
  const mousePointTo = {
    x: (pointer.x - stage.x()) / oldScale,
    y: (pointer.y - stage.y()) / oldScale,
  };

  // Определяем направление (deltaY > 0 – отдаление, < 0 – приближение)
  const direction = e.evt.deltaY > 0 ? -1 : 1;

  // Считаем новый масштаб
  const newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

  // Устанавливаем масштаб
  stage.scale({ x: newScale, y: newScale });

  // Рассчитываем сдвиг так, чтобы точка под курсором «осталась на месте»
  const newPos = {
    x: pointer.x - mousePointTo.x * newScale,
    y: pointer.y - mousePointTo.y * newScale,
  };
  stage.position(newPos);
  stage.batchDraw();
};

export const frameColumns = [
  {
    name: "frame_param_type_name",
    label: "Параметр",
    field: "frame_param_type_name",
    align: "left",
  },
  {
    name: "param_value",
    label: "Значение",
    field: "param_value",
    align: "right",
  },
];
